export const environment = {
  
  production: false,
  baseurl: '/ihs',
  wsurl: '/ihs/',

  wfmurl:"",
  itocRedirectUrl:"",

   itocUrl:"/",
} 